import { SHIPPING_TYPES, ShippingTypeEnum } from "../constants";

interface ShippingTypeBadgesProps {
  types: ShippingTypeEnum[];
}

export function ShippingTypeBadges({
  types,
}: ShippingTypeBadgesProps): JSX.Element {
  return (
    <div className="flex flex-wrap gap-1">
      {SHIPPING_TYPES.filter((type) => types.includes(type.value)).map(
        (type) => (
          <span
            key={type.value}
            tabIndex={0}
            title={type.microcopy}
            aria-label={`${type.label} — ${type.microcopy}`}
            className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium focus:outline-none focus:ring-2 focus:ring-[#613F4F] focus:ring-offset-1 ${type.badgeClassName}`}
          >
            {type.label}
          </span>
        )
      )}
    </div>
  );
}
